module.exports = __webpack_public_path__ + "img/dog.379179b6.svg";